import React from "react";
import SectionShell from "./SectionShell";

const STORIES = [
  "Nekem mindig mindent egyedül kell megoldanom.",
  "Az én érzéseim kevésbé fontosak.",
  "Csak akkor vagyok szerethető, ha hasznos vagyok.",
  "A konfliktus veszélyes.",
  "A jó anya mindig…",
  "A férfiak ilyenek…",
  "Én már csak ilyen vagyok.",
];

export default function BehindStoriesSection() {
  return (
    <SectionShell
      id="tortenetek-mogott"
      testId="behind-stories-section"
      eyebrow="A felismerés pillanata"
      titleStart="Mi történik, amikor a"
      titleAccent="történeteink"
      titleEnd=" mögé nézünk?"
      tinted
    >
      <p>
        A közös munka során gyakran olyan összefüggések válnak láthatóvá, amelyek addig rejtve
        maradtak. A történetek mögött olyan nézőpontok és működési mechanizmusok húzódnak meg,
        amelyeket sokszor magától értetődő igazságként kezeltünk. Az első lépés a felismerés.
        Amikor láthatóvá válik, mi mozgatja valójában azokat a helyzeteket, amelyek újra és
        újra visszatérnek az életünkben. Néhány példa:
      </p>

      {/* Elegant story examples — soft framed panel, no bullets */}
      <aside
        data-testid="behind-stories-examples"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-8 md:py-9"
      >
        <ul
          data-testid="behind-stories-list"
          className="list-none space-y-3 md:space-y-4 text-center"
        >
          {STORIES.map((s, idx) => (
            <li
              key={s}
              className="font-serif-display italic text-graphite text-[17px] md:text-[18.5px] leading-[1.55]"
            >
              {s}
              {idx < STORIES.length - 1 && (
                <span aria-hidden="true" className="block mx-auto mt-3 md:mt-4 w-3 h-px bg-[var(--accent-gold)] opacity-50" />
              )}
            </li>
          ))}
        </ul>
      </aside>

      <p>
        Sokszor nem is kérdőjelezzük meg ezeket. Egyszerűen tényként kezeljük őket. Olyan
        mélyen a részünkké válnak, hogy el sem tudjuk képzelni, hogy más valóság is létezhet.
        Amikor azonban ezek a meggyőződések láthatóvá válnak, valami megmozdul a térben. Nem
        feltétlenül jelenik meg azonnal az életünkben, bár erre is van példa. Hanem először
        belül megy végbe a változás. Hiszen valójában nem a múlt átírása történik. Nem a másik
        ember megváltoztatása. Nem a körülmények lecserélése. Hanem az, hogy az ember végre
        meglátja: mindig több lehetősége volt, mint amennyit addig látott. A közös munka során
        ezeket a mélyen rejlő mechanizmusokat és energetikai mozgató rugókat kezdjük egyénileg
        feltérképezni, tudatosítani és energetikailag kiigazítani. A kérdés ezután már nem az,
        hogy van-e lehetőség a változásra. Hanem az, hogy készen állunk-e teret adni valami
        újnak. Mert ahogy láthatóvá válnak azok a minták és működési mechanizmusok, amelyek
        addig észrevétlenül irányították az életünket, valami lassan átrendeződik. Nem kívül.
        Először önmagunkban. Ennek pedig természetes következménye, hogy megváltozik az
        érzékelésünk. Másként kezdünk kapcsolódni önmagunkhoz, másokhoz, a lehetőségeinkhez,
        és gyakran azt vesszük észre, hogy az életünkben is valami megmozdult. Nem azért, mert
        erővel megváltoztattuk. Hanem mert mi magunk már nem ugyanonnan nézünk rá.
      </p>
    </SectionShell>
  );
}
